
  var _styles = {
  "double-card-container-double": {
    "fontFamily": "PingFang SC",
    "width": "4.6rem",
    "height": "6.49333rem",
    "marginBottom": "0.26667rem",
    "display": "flex",
    "flexDirection": "column",
    "position": "relative",
    "borderRadius": "0.24rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "double-card-image-view": {
    "width": "100%",
    "height": "3.44rem",
    "overflow": "hidden",
    "borderRadius": "0.24rem 0.24rem 0 0"
  },
  "double-card-image": {
    "width": "100%",
    "height": "100%",
    "borderRadius": "0.24rem 0.24rem 0 0",
    "OObjectFit": "cover",
    "objectFit": "cover"
  },
  "double-card-image-tag": {
    "position": "absolute",
    "width": "0.96rem",
    "height": "0.48rem",
    "top": 0,
    "left": "-0.05333rem",
    "zIndex": 10
  },
  "double-departures-container": {
    "position": "absolute",
    "left": "0.8rem",
    "top": 0,
    "zIndex": 9
  },
  "double-departures-background": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "100%",
    "height": "0.42667rem",
    "zIndex": 11
  },
  "double-departures-text": {
    "height": "0.42667rem",
    "fontSize": "0.25333rem",
    "color": "rgb(228,225,225)",
    "zIndex": 12,
    "paddingLeft": "0.22667rem",
    "paddingRight": "0.13333rem",
    "lineHeight": "0.42667rem"
  },
  "double-card-content-right": {
    "flex": 1,
    "width": "100%",
    "height": "3.05333rem",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "boxSizing": "border-box",
    "display": "flex",
    "flexDirection": "column"
  },
  "double-card-top-field": {
    "width": "100%",
    "display": "flex"
  },
  "double-card-tag-field": {
    "marginTop": "0.04rem",
    "paddingTop": "0.13333rem",
    "paddingRight": "0.16rem",
    "paddingBottom": 0,
    "paddingLeft": "0.16rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "double-card-day-tag": {
    "borderTopLeftRadius": "0.08rem",
    "borderTopRightRadius": "0.08rem",
    "borderBottomLeftRadius": "0.08rem",
    "borderBottomRightRadius": "0.08rem",
    "overflow": "hidden",
    "width": "0.42667rem",
    "maxWidth": "0.42667rem",
    "height": "0.42667rem",
    "marginRight": "0.06667rem",
    "marginBottom": "-0.06667rem"
  },
  "double-card-day-tag-text": {
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "backgroundColor": "rgb(255,209,0)"
  },
  "double-card-deal-name": {
    "position": "relative",
    "fontSize": "0.37333rem",
    "width": "4.26667rem",
    "lineHeight": "0.53333rem",
    "textAlign": "left",
    "verticalAlign": "bottom"
  },
  "double-card-day-h5-tag-view": {
    "position": "absolute",
    "top": "0.06667rem",
    "left": 0,
    "textAlign": "center",
    "height": "0.37333rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "borderRadius": "0.08rem",
    "backgroundColor": "rgb(255,209,0)",
    "marginRight": "0.06667rem"
  },
  "double-card-day-h5-tag-text": {
    "color": "rgb(34,0,0)",
    "lineHeight": "0.37333rem",
    "fontWeight": "500",
    "fontSize": "0.26667rem"
  },
  "double-card-deal-name-text": {
    "color": "rgb(34,34,33)",
    "fontSize": "0.37333rem",
    "fontWeight": "500",
    "lineHeight": "0.53333rem"
  },
  "double-card-tag": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "marginTop": "0.06667rem",
    "marginRight": "0.16rem",
    "marginBottom": "0.06667rem",
    "marginLeft": "0.16rem",
    "minHeight": "0.37333rem",
    "padding": "0.00133rem"
  },
  "double-card-product-tag-group": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(77,153,0,0.2980392157)",
    "marginRight": "0.08rem",
    "whiteSpace": "nowrap",
    "minHeight": "0.37333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "double-card-product-tag-text-group": {
    "color": "rgb(77,153,0)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "double-card-people-tag": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(142,60,18,0.2980392157)",
    "marginRight": "0.08rem",
    "minHeight": "0.37333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "double-card-people-tag-text": {
    "color": "rgb(142,60,18)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "double-card-product-tag-free": {
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgba(7,119,238,0.2980392157)",
    "marginRight": "0.08rem",
    "whiteSpace": "nowrap",
    "minHeight": "0.37333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "double-card-product-tag-text-free": {
    "color": "rgb(7,119,238)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginTop": 0,
    "marginRight": "0.08rem",
    "marginBottom": 0,
    "marginLeft": "0.08rem"
  },
  "double-card-bottom-field": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "justifyContent": "space-between",
    "flex": 1,
    "paddingTop": 0,
    "paddingRight": "0.13333rem",
    "paddingBottom": "0.25333rem",
    "paddingLeft": "0.13333rem",
    "width": "100%",
    "height": "1.06667rem"
  },
  "double-card-bottom-left-field": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start"
  },
  "double-card-price-now": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "color": "rgb(255,39,39)",
    "fontWeight": "600",
    "fontSize": "0.48rem"
  },
  "double-card-price-icon": {
    "color": "rgb(255,39,39)",
    "fontWeight": "600",
    "fontSize": "0.32rem"
  },
  "double-card-price-price": {
    "fontWeight": "800",
    "fontSize": "0.45333rem",
    "marginLeft": "0.02667rem",
    "marginRight": "0.12rem",
    "color": "rgb(255,39,39)"
  },
  "double-card-price-start": {
    "color": "rgb(102,102,102)",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "marginRight": "0.05333rem",
    "marginLeft": "-0.08rem",
    "marginBottom": "0.02667rem"
  },
  "double-card-price-origin": {
    "textDecoration": "line-through",
    "WebkitTextDecorationColor": "#666",
    "textDecorationColor": "#666",
    "color": "rgb(102,102,102)",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "marginBottom": "0.02667rem"
  },
  "double-card-discount-width-field": {
    "height": "0.37333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "double-card-discount-left-field": {
    "alignSelf": "flex-start",
    "borderTopLeftRadius": "0.08rem",
    "borderBottomLeftRadius": "0.08rem",
    "display": "flex",
    "flexDirection": "row",
    "lineHeight": "0.37333rem",
    "height": "100%"
  },
  "double-card-discount-img": {
    "height": "0.37333rem",
    "width": "0.37333rem"
  },
  "double-card-discount-width-text": {
    "color": "rgb(255,255,255)",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "paddingBottom": "0.02rem",
    "marginRight": "0.02667rem"
  },
  "double-card-discount-right-field": {
    "height": "0.37333rem",
    "display": "flex",
    "alignSelf": "flex-start",
    "flexDirection": "row",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,75,16)",
    "borderRadius": "0 0.08rem 0.08rem 0"
  },
  "double-card-curve-img": {
    "height": "0.37333rem",
    "width": "0.10667rem",
    "marginLeft": "-0.02667rem"
  },
  "double-card-reduce-text": {
    "lineHeight": "0.37333rem",
    "fontFamily": "MTNewDigitalDisplay-Regular",
    "color": "rgb(255,75,16)",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "marginRight": "0.08rem"
  },
  "double-card-discount-field": {
    "height": "0.37333rem",
    "marginTop": "-0.04rem",
    "display": "flex",
    "flexDirection": "row",
    "alignSelf": "flex-start",
    "borderRadius": "0.08rem"
  },
  "double-card-discount-text": {
    "color": "rgb(255,255,255)",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "marginRight": "0.08rem",
    "marginTop": "0.01333rem"
  },
  "double-card-bottom-right-field": {
    "borderRadius": "0.4rem",
    "height": "0.8rem",
    "width": "1.38667rem",
    "position": "absolute",
    "right": "0.16rem",
    "bottom": "0.24rem",
    "overflow": "hidden"
  },
  "double-card-bottom-right-text": {
    "color": "rgb(255,255,255)",
    "fontWeight": "600",
    "fontSize": "0.37333rem"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTNewDigitalDisplay-Regular', 'url("https://s3plus.meituan.net/trip-supplier/mcp-static/MTNewDigitalDisplay-Regular.otf") format("opentype")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https: //s3plus.meituan.net/trip-supplier/mcp-static/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
  }
    


  module.exports = _styles;
  